import { SeatDetails, SsrDetails } from '@tff/types/tff/tfa-amend-ancillary-service';

export enum AncillaryType {
  Sports = 'SPORTS',
  Animals = 'ANIMALS',
  HandLuggage = 'HAND_LUGGAGE',
  Baggage = 'BAGGAGE',
  AdditionalBaggage = 'ADDITIONAL_BAGGAGE',
}

export type SeatsByPax = { [paxId: string]: SeatDetails };

export type SurchargeType = { [key: string]: string };

export type SsrsByPax = { [paxId: string]: SsrDetails[] };

export type SsrsByBond = {
  outbound: SsrDetails[];
  return: SsrDetails[];
};

export type PaxObject = Record<string, SsrDetails[]>;
